import { config, msg } from 'api';
import { setErrorMessage } from 'apps/notifications/actions/notifications';
import { wa, pageEventTypes } from 'apps/analytics';
import { pageEvents } from 'apps/settings/analytics';

import { gtm } from 'apps/gtm';
import errorHandler from 'lib/utils/errorHandler';
import { isUserLoggedIn } from 'apps/user/helpers';
import { Features } from 'apps/settings/consts';

export const SET_MARKETING_COMMUNICATIONS_PREFERENCE = 'SET_MARKETING_COMMUNICATIONS_PREFERENCE';
export const SET_MARKETING_COMMUNICATIONS_CONSENTS = 'SET_MARKETING_COMMUNICATIONS_CONSENTS';
export const OWN_OFFERS_FIELD_NAME = 'OWN_OFFERS';
export const THIRD_PARTY_OFFERS_FIELD_NAME = 'THIRD_PARTY_OFFERS';

export function setMarketingCommunicationsPreference(offerParams) {
  return {
    type: SET_MARKETING_COMMUNICATIONS_PREFERENCE,
    offerParams,
  };
}

export function saveMarketingCommunicationsPreference(ownOffers, thirdPartyOffers) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/marketing-communications`,
      {
        body: JSON.stringify({
          ownOffersEnabled: ownOffers,
          thirdPartyOffersEnabled: thirdPartyOffers,
        }),
      })
      .then(() => {
        wa.triggerPageEvent(pageEventTypes.MARKETING_COMMUNICATIONS_SUCCESS_NOTIFICATION_DISPLAYED, {
          [OWN_OFFERS_FIELD_NAME]: ownOffers,
          [THIRD_PARTY_OFFERS_FIELD_NAME]: thirdPartyOffers,
        });
        dispatch(setMarketingCommunicationsPreference({ ownOffers, thirdPartyOffers }));
        return true;
      })
      .catch(() => {
        wa.triggerPageEvent(pageEventTypes.MARKETING_COMMUNICATIONS_ERROR_NOTIFICATION_DISPLAYED, {
          [OWN_OFFERS_FIELD_NAME]: ownOffers,
          [THIRD_PARTY_OFFERS_FIELD_NAME]: thirdPartyOffers,
        });
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        return false;
      });
}

export function getMarketingCommunicationsPreference() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/marketing-communications`)
      .then(response =>
        dispatch(setMarketingCommunicationsPreference({
          ownOffers: response.ownOffersEnabled,
          thirdPartyOffers: response.thirdPartyOffersEnabled,
        }))
      )
      .catch(errorHandler);
}

export function setMarketingCommunicationsConsents(marketingConsents) {
  return {
    type: SET_MARKETING_COMMUNICATIONS_CONSENTS,
    marketingConsents,
  };
}

export function saveMarketingCommunicationsConsents(consents) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/consents`,
      {
        body: JSON.stringify(consents),
      })
      .then(() => {
        wa.triggerPageEventWithDescription(
          pageEvents.MARKETING_COMMUNICATIONS_SUCCESS_NOTIFICATION_DISPLAYED_AFTER_SAVING
        );
        gtm.trigger('gtm:consentsChangedEvent', consents);
        dispatch(setMarketingCommunicationsConsents(consents));
        return true;
      })
      .catch(() => {
        wa.triggerPageEventWithDescription(
          pageEvents.MARKETING_COMMUNICATIONS_ERROR_NOTIFICATION_DISPLAYED_AFTER_SAVING
        );
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        return false;
      });
}

export function getMarketingCommunicationsConsents() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/consents`)
      .then(response =>
        dispatch(setMarketingCommunicationsConsents(response))
      )
      .catch(errorHandler);
}

export function getMarketingCommunications() {
  return (dispatch, getState, { network }) => {
    const useGDPR = getState().user.features.includes(Features.GDPR_MARKETING_COMMUNICATIONS);
    return useGDPR ?
      getMarketingCommunicationsConsents()(dispatch, getState, { network })
      :
      getMarketingCommunicationsPreference()(dispatch, getState, { network });
  };
}

export function ensureMarketingCommunicationsConsents() {
  return (dispatch, getState) => {
    const { user } = getState();
    const useGDPR = user.features.includes(Features.GDPR_MARKETING_COMMUNICATIONS);
    if (isUserLoggedIn(user) && useGDPR) {
      return dispatch(getMarketingCommunicationsConsents());
    } else {
      return null;
    }
  };
}
